import React, { useMemo } from "react";
import { type MenuListProps, type GroupBase } from "react-select";
import LazyList from "../../common/LazyList/LazyList";
import type { SelectOption } from "./Select";

interface VirtualizedMenuListProps extends MenuListProps<SelectOption, false, GroupBase<SelectOption>> {}

const VirtualizedMenuList = ({ children, innerRef, maxHeight }: VirtualizedMenuListProps) => {
  const rows = useMemo(() => React.Children.toArray(children), [children]);

  return (
    <LazyList
      className="deci-select__menu-list"
      scrollClassName="deci-select__menu-list"
      style={{ maxHeight: maxHeight ?? 300 }}
      scrollRef={innerRef}
      items={rows}
      getItemKey={(_, index) => index}
      virtualizeThreshold={100}
      renderItem={(item) => item}
    />
  );
};

export default VirtualizedMenuList;
